import { Column, Entity } from 'typeorm';
import { BaseEntity } from './base.entity';

@Entity('_prompt_history')
export class PromptHistoryEntity extends BaseEntity {
	@Column('varchar', { name: 'prompt', length: 255 })
	public prompt!: string;

	@Column('text', { name: 'explanation' })
	public explanation!: string;

	@Column('text', { name: 'query' })
	public query!: string;
}
